import React from "react";
const ExitIcon = () => {
  return (
    <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg">
      <rect
        fill="none"
        id="canvas_background"
        height="42"
        width="42"
        y="-1"
        x="-1"
      />
      <g>
        <g stroke="null" id="svg_1">
          <g id="svg_2">
            <rect
              fill="#fff"
              id="svg_3"
              height="84.9"
              width="5"
              transform="rotate(-45 46.373 16.607) scale(.50678)"
              y="-41.72"
              x="47.448"
            />
          </g>
          <g id="svg_4">
            <rect
              fill="#fff"
              id="svg_5"
              height="5"
              width="84.9"
              transform="rotate(-45 46.373 16.607) scale(.50678)"
              y="-1.82"
              x="7.548"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ExitIcon;



// WEBPACK FOOTER //
// ./src/components/ExitIcon.js